// extracted by mini-css-extract-plugin
export var labelWrapper = "_mc-0";